"use strict";
if ($('#vue-postcontroller').length) {
    var pc = new Vue({
        el: '#vue-postcontroller',
        data: {
            id: null,
            title: null,
            topicsView: [],
            topics: null,
            message: null,
            errormessage: null,
            actions: [],
            loginUrl: null,
            showSubscribe: false,
            subscriberId: null,
            subscribeSuccess: false,
            registerEmail: null,
            interestNews: null,
            isSubscriber: false,
            isFav: null,
            userInfo: null
        },
        created: function () {
            this.getInterestNews();
        },
        mounted: function () {
            epicaAddEventClick('#vue-postcontroller');
        },
        beforeMount: function () {
            this.id = parseInt(this.$el.attributes['data-post-id'].value);
            this.title = this.$el.attributes['data-post-title'].value;
            this.loginUrl = this.$el.attributes['data-loginurl'].value;
            this.topics = JSON.parse(this.$el.attributes['data-post-topics'].value);
            this.message = null;
            this.actions = [];
            this.loadUserInfo();
        },
        methods: {
            clearMsg: function () {
                this.message = null;
                this.actions = [];
            },
            execute: function (item) {
                if (item.exec) {
                    switch (item.exec) {
                        case 'subscribe':
                            this.showSubscribe = true;
                            break;
                        default:
                            break;
                    }
                }
            },
            closeSubscribe: function () {
                this.showSubscribe = false;
            },
            loadUserInfo: function () {
                var _self = this;
                this.$http.post('/api/user/info').then(function (response) {
                    _self.userInfo = response.body;
                    _self.isSubscriber = _self.userInfo.isSubscriber;
                    _self.isFav = _self.userInfo.favorites.indexOf(_self.id) >= 0;

                    _self.topics.forEach(function (item) {
                        item.IsLoading = false;
                        item.IsSelected = _self.userInfo.topics.indexOf(item.Id) >= 0;
                    });
                });
            },
            updateFav: function () {

                var objToSend = {
                    PostId: this.id,
                    PostTitle: this.title
                };
                this.$http.post('/api/lrplus/favs', objToSend).then(function (response) {

                    if (response.body.success) {

                        this.isFav = !this.isFav;
                        if (this.isFav) {
                            this.message = "Artículo guardado";
                            setTimeout(this.clearMsg, 3000);
                        } else {
                            this.message = "Artículo eliminado";
                            setTimeout(this.clearMsg, 3000);
                        }

                    } else {

                        switch (response.body.errorCode) {
                            case "limit":
                                this.message = this.isSubscriber ? "Ha superado el límite de favoritos" : "Ha llegado al límite de favoritos, suscríbase para ampliar el número de artículos que puede guardar.";
                                if (!this.isSubscriber) {
                                    this.actions.push({ title: "Suscribirse", exec: "subscribe" });
                                    this.actions.push({ title: "Administrar Favoritos", href: "//mas.larepublica.co/articulos-guardados" });
                                }
                                break;
                            case "auth":
                                this.message = "Debe ingresar para guardar el artículo";
                                this.actions.push({ title: "ingresar", href: this.loginUrl });
                                setTimeout(this.clearMsg, 10000);
                                break;
                            default:
                                this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                                setTimeout(this.clearMsg, 3000);
                                break;
                        }
                    }

                }, function (response) {
                    this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                    setTimeout(this.clearMsg, 3000);
                });
            },
            addTopic: function (topic, idx) {
                topic.IsLoading = true;

                this.$http.post('/api/lrplus/topics', topic).then(function (response) {
                    topic.IsLoading = false;

                    if (response.body.success) {
                        topic.IsSelected = true;
                        this.message = "Tema agregado satisfactoriamente.";
                        setTimeout(this.clearMsg, 3000);
                    } else {
                        switch (response.body.errorCode) {
                            case "limit":
                                this.message = this.isSubscriber ? "Ha superado el límite de temas" : "Ha superado el límite de temas, suscribase para poder agregar más.";
                                if (!this.isSubscriber) {
                                    this.actions.push({ title: "Suscribirse", exec: "subscribe" });
                                    this.actions.push({ title: "Administrar Temas", href: "//mas.larepublica.co/noticias/mis-temas" });
                                }
                                break;
                            case "auth":
                                this.message = "Debe ingresar para agregar el tema.";
                                this.actions.push({ title: "ingresar", href: this.loginUrl });
                                setTimeout(this.clearMsg, 10000);
                                break;
                            default:
                                this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                                setTimeout(this.clearMsg, 3000);
                                break;
                        }
                    }

                }, function (response) {
                    topic.IsLoading = false;
                    this.message = "Ha ocurrido un error, intente de nuevo más tarde.";
                    setTimeout(this.clearMsg, 3000);
                });
            },
            subscribe: function () {
                if (this.subscriberId) {
                    var subscriber = {
                        Identification: this.subscriberId
                    };
                    this.$http.post('/api/lrplus/subscribe', subscriber).then(function (response) {
                        if (response.body.success) {
                            this.subscribeSuccess = true;

                        } else {
                            this.errormessage = response.body.errorMessage;
                            setTimeout(this.clearErrorMessage, 5000);
                        }
                    }, function (response) {
                        this.errormessage = "Ha ocurrido un error por favor intente de nuevo más tarde";
                        setTimeout(this.clearErrorMessage, 5000);
                    });
                } else {
                    this.errormessage = "Ingrese su número de identificación para poder continuar";
                    setTimeout(this.clearErrorMessage, 5000);
                }
            },
            clearErrorMessage: function () {
                this.errormessage = null;
            },
            registerUser: function () {
                if (this.registerEmail) {
                    var urlRegister = keycloak.createRegisterUrl({ loginHint: this.registerEmail });
                    document.location.href = urlRegister;
                }
            },
            getInterestNews() {
                const _self = this;
                setTimeout(() => {
                    if (window.epica) {
                        window.epica("recommend", 15, function (error, data) {
                            if (error) {
                                console.error(error);
                            } else {
                                const ids = data.buckets[0].items.map((q) => q.id);
                                _self.$http.get("/api/epica/suggest", {
                                    params: {
                                        Ids: ids,
                                    },
                                })
                                    .then(function (d) {
                                        _self.interestNews = d.data;
                                        setTimeout(function () {
                                            epicaAddEventClick('#vue-postcontroller');
                                            onResize();
                                            lazyLoadInit();
                                        }, 200);
                                    });
                            }
                        });
                    } else {
                        _self.getInterestNews();
                    }
                }, 200);
            }
        }
    });
}